import { useQuery } from 'react-query'
import { getSettingsAll } from 'services/cmAPI/getSettingsAll'

export function useGetSettingsAll(id: number) {
  return useQuery(['getSettingsAll'], () => getSettingsAll(id), {})
}
